(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // La suggestion dépend du contenu du panier. Quand Horizon met le panier à jour sans
    // recharger la page (quantité, suppression), on redemande cette section au serveur.
    function init() {
      var holder = document.querySelector('[data-nh-cart]');
      var cartPage = document.querySelector('.cart-page');
      if (!holder || !cartPage || holder.dataset.nhReady) return;
      holder.dataset.nhReady = 'true';

      var target = cartPage.closest('.shopify-section') || cartPage.parentElement;
      var timer = null;
      var request = null;

      function refresh() {
        if (request) request.abort();
        request = new AbortController();
        holder.setAttribute('aria-busy', 'true');
        fetch(window.location.pathname + '?section_id=' + encodeURIComponent(holder.dataset.sectionId), {
          signal: request.signal,
          headers: { Accept: 'text/html' },
        })
          .then(function (response) {
            return response.ok ? response.text() : Promise.reject(new Error('section'));
          })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nh-cart-content]');
            var current = holder.querySelector('[data-nh-cart-content]');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          })
          .catch(function () {})
          .finally(function () {
            holder.removeAttribute('aria-busy');
          });
      }

      new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(refresh, 400);
      }).observe(target, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('.nh-film').forEach(function (section) {
        if (section.dataset.nhReady) return;
        section.dataset.nhReady = 'true';

        var videos = Array.prototype.slice.call(section.querySelectorAll('.nh-film__video'));
        var items = Array.prototype.slice.call(section.querySelectorAll('.nh-film__item'));
        var mobile = window.matchMedia('(max-width: 749px)');

        videos.forEach(function (video) {
          var button = video.parentElement.querySelector('.nh-film__play');
          if (!button) return;

          // Sans script, le lecteur natif reste disponible. Avec script, un bouton unique lance le film.
          video.removeAttribute('controls');
          button.hidden = false;

          button.addEventListener('click', function () {
            videos.forEach(function (other) {
              if (other !== video) other.pause();
            });
            button.hidden = true;
            video.setAttribute('controls', '');
            video.play();
          });

          video.addEventListener('play', function () {
            videos.forEach(function (other) {
              if (other !== video) other.pause();
            });
          });
        });

        function setOpen(item, open) {
          var toggle = item.querySelector('.nh-film__toggle');
          item.classList.toggle('is-open', open);
          if (toggle && mobile.matches) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) {
            var video = item.querySelector('.nh-film__video');
            if (video) video.pause();
          }
        }

        items.forEach(function (item) {
          var toggle = item.querySelector('.nh-film__toggle');
          if (!toggle) return;
          toggle.addEventListener('click', function () {
            if (!mobile.matches || item.classList.contains('is-open')) return;
            items.forEach(function (other) {
              setOpen(other, other === item);
            });
          });
        });

        // Sur ordinateur les titres ne sont pas des commandes : on les retire du parcours clavier.
        function sync() {
          items.forEach(function (item) {
            var toggle = item.querySelector('.nh-film__toggle');
            if (!toggle) return;
            if (mobile.matches) {
              toggle.removeAttribute('tabindex');
              toggle.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
            } else {
              toggle.setAttribute('tabindex', '-1');
              toggle.removeAttribute('aria-expanded');
            }
          });
        }

        sync();
        mobile.addEventListener('change', sync);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-heritage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-nh-heritage-film]').forEach(function (film) {
        if (film.dataset.nhReady) return;
        film.dataset.nhReady = 'true';

        var video = film.querySelector('video');
        var controls = film.querySelector('.nh-heritage__film-controls');
        if (!video || !controls) return;
        var playButton = controls.querySelector('[data-nh-film="play"]');
        var soundButton = controls.querySelector('[data-nh-film="sound"]');
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var userPaused = reduced;

        video.muted = true;
        video.removeAttribute('controls');
        controls.hidden = false;

        function setState(button, on) {
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
          button.setAttribute('aria-label', on ? button.dataset.labelOn : button.dataset.labelOff);
        }

        function play() {
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () { setState(playButton, true); });
        }

        video.addEventListener('play', function () { setState(playButton, false); });
        video.addEventListener('pause', function () { setState(playButton, true); });

        playButton.addEventListener('click', function () {
          if (video.paused) {
            userPaused = false;
            play();
          } else {
            userPaused = true;
            video.pause();
          }
        });

        soundButton.addEventListener('click', function () {
          video.muted = !video.muted;
          setState(soundButton, !video.muted);
          if (!video.muted && video.paused) {
            userPaused = false;
            play();
          }
        });

        if (reduced) {
          setState(playButton, true);
          return;
        }

        if (!('IntersectionObserver' in window)) {
          play();
          return;
        }

        new IntersectionObserver(function (entries) {
          var visible = entries[0].isIntersecting;
          if (visible && !userPaused && video.paused) play();
          if (!visible && !video.paused) video.pause();
        }, { threshold: 0.35 }).observe(video);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('.nh-hero').forEach(function (hero) {
        if (hero.dataset.nhReady) return;
        hero.dataset.nhReady = 'true';

        var video = hero.querySelector('.nh-hero__video');
        var button = hero.querySelector('.nh-hero__sound');
        if (!video) return;

        // En-tête translucide sur la vidéo (ordinateur) : il redevient opaque quand la moitié
        // de la vidéo est passée sous lui.
        var media = hero.querySelector('.nh-hero__media');
        if (media && 'IntersectionObserver' in window) {
          var headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 66;
          new IntersectionObserver(function (entries) {
            document.documentElement.classList.toggle('nh-header-solid', entries[0].intersectionRatio < 0.5);
          }, { rootMargin: '-' + Math.round(headerHeight) + 'px 0px 0px 0px', threshold: [0, 0.5, 1] }).observe(media);
        }

        // La lecture automatique reste toujours muette : le son ne s'active que par le bouton.
        video.muted = true;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.removeAttribute('autoplay');
          video.pause();
          video.setAttribute('controls', '');
        }

        if (!button) return;
        var label = button.querySelector('.nh-hero__sound-label');

        button.addEventListener('click', function () {
          video.muted = !video.muted;
          var soundOn = !video.muted;
          button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          label.textContent = soundOn ? button.dataset.labelOn : button.dataset.labelOff;
          if (soundOn && video.paused) video.play();
        });
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-manifeste"] && !Shopify.designMode) return;
  try {
    
  // Phrase manifeste : les mots passent d'une teinte estompée à l'encre, dans l'ordre de lecture,
  // au rythme du défilement. Mouvement réduit demandé : texte affiché directement.
  (function () {
    var START = 0.88; // le haut de la phrase atteint 88 % de la hauteur de l'écran : début
    var END = 0.42; // le bas de la phrase atteint 42 % : tout est révélé
    var FADED = 0.2;
    var quotes = [];
    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      quotes.forEach(function (quote) {
        if (quote.last === 1) return;
        var rect = quote.el.getBoundingClientRect();
        var distance = START * vh - END * vh + rect.height;
        var progress = (START * vh - rect.top) / distance;
        // Un mot révélé ne s'estompe plus, même si l'on remonte la page
        progress = Math.min(1, Math.max(quote.last, progress));
        if (progress === quote.last) return;
        quote.last = progress;
        var count = quote.words.length;
        var spread = 4; // chaque mot fonce sur la durée de quelques mots : fondu progressif
        var position = progress * (count + spread);
        quote.words.forEach(function (word, index) {
          var amount = Math.min(1, Math.max(0, (position - index) / spread));
          word.style.opacity = (FADED + (1 - FADED) * amount).toFixed(3);
        });
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    function init(root) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      (root || document).querySelectorAll('[data-nh-quote-reveal]').forEach(function (el) {
        if (el.dataset.nhReady) return;
        el.dataset.nhReady = 'true';
        quotes.push({ el: el, words: Array.prototype.slice.call(el.querySelectorAll('.nh-manifeste__word')), last: 0 });
      });
      quotes.forEach(function (quote) {
        quote.words.forEach(function (word) {
          word.style.opacity = FADED;
        });
      });
      update();
    }

    // Écoute en phase de capture : sur certaines mises en page, c'est un conteneur
    // de la page qui défile, pas la fenêtre (l'événement « scroll » ne remonte pas).
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-points-de-vente"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('.nh-pdv__feature').forEach(function (feature) {
        if (feature.dataset.nhReady) return;
        feature.dataset.nhReady = 'true';

        var slides = Array.prototype.slice.call(feature.querySelectorAll('[data-nh-pdv-slide]'));
        var visuals = Array.prototype.slice.call(feature.querySelectorAll('[data-nh-pdv-visual]'));
        var nav = feature.querySelector('.nh-pdv__nav');
        var current = feature.querySelector('[data-nh-pdv-current]');
        var prev = feature.querySelector('[data-nh-pdv-prev]');
        var next = feature.querySelector('[data-nh-pdv-next]');
        if (slides.length < 2 || !nav || !prev || !next) return;

        var index = 0;

        function show(target) {
          index = (target + slides.length) % slides.length;
          slides.forEach(function (slide, i) {
            slide.classList.toggle('is-active', i === index);
            slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          });
          visuals.forEach(function (visual, i) {
            visual.classList.toggle('is-active', i === index);
          });
          // La zone image n'existe que si le point de vente affiché a une photo.
          feature.classList.toggle('has-media', !!(visuals[index] && visuals[index].querySelector('img')));
          if (current) current.textContent = String(index + 1);
        }

        prev.addEventListener('click', function () {
          show(index - 1);
        });
        next.addEventListener('click', function () {
          show(index + 1);
        });

        // Glissement au doigt : un geste horizontal net change de point de vente.
        var startX = null;
        var startY = null;
        feature.addEventListener(
          'touchstart',
          function (event) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );
        feature.addEventListener(
          'touchend',
          function (event) {
            if (startX === null) return;
            var dx = event.changedTouches[0].clientX - startX;
            var dy = event.changedTouches[0].clientY - startY;
            startX = null;
            if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
            show(dx < 0 ? index + 1 : index - 1);
          },
          { passive: true }
        );

        // Dans l'éditeur de thème, sélectionner un bloc affiche son point de vente.
        feature.addEventListener('shopify:block:select', function (event) {
          var target = slides.indexOf(event.target);
          if (target > -1) show(target);
        });

        nav.hidden = false;
        show(0);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-product-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-nh-product-film]').forEach(function (player) {
        if (player.dataset.nhReady) return;
        player.dataset.nhReady = 'true';
        var video = player.querySelector('video');
        var cover = player.querySelector('.nh-product-film__cover');
        if (!video || !cover) return;

        // Au clic : lecture muette avec les commandes natives (le son reste au choix du visiteur)
        cover.addEventListener('click', function () {
          cover.hidden = true;
          video.muted = true;
          video.setAttribute('controls', '');
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        });

        // Film hors écran : pause
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting && !video.paused) video.pause();
            });
          }).observe(player);
        }
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-product-notes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mobile : la pyramide (section entière) est déplacée dans la zone d'achat de la fiche, juste
    // avant les volets Description / À savoir, ouverte. Ordinateur : elle revient à sa place.
    var mobile = window.matchMedia('(max-width: 749px)');
    var home = null;

    function apply() {
      var section = document.querySelector('.nh-section.nh-notes');
      var notes = document.querySelector('[data-nh-notes-accordion]');
      if (!section || !notes) return;
      var description = document.querySelector('[data-nh-description]');
      var info = document.querySelector('.nh-product__info');
      var details = info ? info.querySelector('.nh-product__details') : null;
      if (!home) home = section.parentElement;

      notes.removeAttribute('name');
      notes.open = true;

      if (mobile.matches && info) {
        if (description) description.open = false;
        if (details) {
          info.insertBefore(section, details);
        } else {
          info.appendChild(section);
        }
      } else {
        if (section.parentElement !== home) home.appendChild(section);
        if (description) description.open = true;
      }
    }

    apply();
    if (mobile.addEventListener) mobile.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-product"] && !Shopify.designMode) return;
  try {
    
  // Galerie mobile : le compteur « 1 / 5 » suit la photo réellement affichée.
  (function () {
    function initCounter(root) {
      (root || document).querySelectorAll('[data-nh-gallery]').forEach(function (wrap) {
        if (wrap.dataset.nhGalleryReady) return;
        wrap.dataset.nhGalleryReady = 'true';
        var gallery = wrap.querySelector('.nh-product__gallery');
        var current = wrap.querySelector('[data-nh-gallery-current]');
        if (!gallery || !current) return;
        var items = gallery.querySelectorAll('.nh-product__media');

        // Quelques photos seulement : lecture directe des positions à chaque défilement
        function update() {
          var start = gallery.getBoundingClientRect().left + parseFloat(getComputedStyle(gallery).paddingLeft);
          var best = 0;
          var bestDistance = Infinity;
          items.forEach(function (item, index) {
            var distance = Math.abs(item.getBoundingClientRect().left - start);
            if (distance < bestDistance) {
              bestDistance = distance;
              best = index;
            }
          });
          // Fin du défilement : la dernière photo est affichée, même étroite
          if (gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 2) best = items.length - 1;
          current.textContent = best + 1;
        }

        gallery.addEventListener('scroll', update, { passive: true });
      });
    }

    initCounter();
    document.addEventListener('shopify:section:load', function (event) {
      initCounter(event.target);
    });
  })();

  // Barre d'achat collante : visible quand le bouton principal est passé au-dessus de l'écran.
  (function () {
    function initSticky(root) {
      (root || document).querySelectorAll('[data-nh-sticky-buy]').forEach(function (bar) {
        if (bar.dataset.nhStickyReady) return;
        bar.dataset.nhStickyReady = 'true';

        var button = bar.querySelector('button');
        var form = document.getElementById(button.getAttribute('form'));
        var main = form && form.querySelector('[type="submit"]');
        if (!main || !('IntersectionObserver' in window)) return;

        function setVisible(visible) {
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          button.tabIndex = visible ? 0 : -1;
        }

        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          // Barre seulement si le bouton est sorti par le haut (déjà dépassé), pas s'il est encore plus bas
          setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }).observe(main);

        // Un seul envoi à la fois (double clic, ou bouton de la fiche puis bouton de la barre)
        form.addEventListener('submit', function (event) {
          if (form.dataset.nhSending) {
            event.preventDefault();
            return;
          }
          form.dataset.nhSending = 'true';
        });
        window.addEventListener('pageshow', function () {
          delete form.dataset.nhSending;
        });

        // Si un choix de variante existe un jour, la barre suit le prix de la variante choisie
        var select = form.querySelector('select[name="id"]');
        var price = bar.querySelector('[data-nh-sticky-price]');
        if (select && price) {
          select.addEventListener('change', function () {
            var option = select.options[select.selectedIndex];
            if (option && option.dataset.price) price.textContent = option.dataset.price;
          });
        }
      });
    }

    initSticky();
    document.addEventListener('shopify:section:load', function (event) {
      initSticky(event.target);
    });
  })();

  (function () {
    function init(root) {
      (root || document).querySelectorAll('.nh-product').forEach(function (product) {
        if (product.dataset.nhZoomReady) return;
        product.dataset.nhZoomReady = 'true';

        var section = product.parentElement;
        var dialog = section.querySelector('[data-nh-lightbox]');
        var triggers = Array.prototype.slice.call(product.querySelectorAll('[data-nh-zoom]'));
        if (!dialog || !dialog.showModal || !triggers.length) return;

        var image = dialog.querySelector('[data-nh-lightbox-image]');
        var count = dialog.querySelector('[data-nh-lightbox-count]');
        var prev = dialog.querySelector('[data-nh-lightbox-prev]');
        var next = dialog.querySelector('[data-nh-lightbox-next]');
        var current = 0;
        var startX = null;

        function show(index) {
          current = (index + triggers.length) % triggers.length;
          image.src = triggers[current].dataset.full;
          image.alt = triggers[current].dataset.alt || '';
          count.textContent = current + 1 + ' / ' + triggers.length;
        }

        if (triggers.length < 2) {
          prev.hidden = true;
          next.hidden = true;
          count.hidden = true;
        }

        triggers.forEach(function (trigger, index) {
          trigger.addEventListener('click', function () {
            show(index);
            dialog.showModal();
          });
        });

        dialog.querySelector('[data-nh-lightbox-close]').addEventListener('click', function () {
          dialog.close();
        });
        image.addEventListener('click', function () {
          dialog.close();
        });
        prev.addEventListener('click', function () {
          show(current - 1);
        });
        next.addEventListener('click', function () {
          show(current + 1);
        });

        dialog.addEventListener('keydown', function (event) {
          if (triggers.length < 2) return;
          if (event.key === 'ArrowLeft') show(current - 1);
          if (event.key === 'ArrowRight') show(current + 1);
        });

        // Glissement au doigt d'une photo à l'autre
        dialog.addEventListener(
          'touchstart',
          function (event) {
            startX = event.touches.length === 1 ? event.touches[0].clientX : null;
          },
          { passive: true }
        );
        dialog.addEventListener(
          'touchend',
          function (event) {
            if (startX === null || triggers.length < 2) return;
            var delta = event.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(delta) > 50) show(delta < 0 ? current + 1 : current - 1);
          },
          { passive: true }
        );

        // À la fermeture : on revient sur la photo qui était agrandie
        dialog.addEventListener('close', function () {
          image.removeAttribute('src');
          triggers[current].focus();
        });
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-reassurance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SPEED = 28; // pixels par seconde
    var RESUME_DELAY = 2500; // reprise après un geste, en millisecondes
    var mobile = window.matchMedia('(max-width: 749px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(root) {
      var list = root.querySelector('[data-nh-trust-list]');
      if (!list || root.dataset.nhReady || root.hasAttribute('data-nh-trust-static')) return;
      root.dataset.nhReady = 'true';

      var originals = Array.prototype.slice.call(list.children);
      var clones = [];
      var position = 0;
      var last = 0;
      var frame = 0;
      var paused = false;
      var resumeTimer = 0;

      // Largeur d'une série complète d'informations (la moitié de la piste une fois doublée)
      function half() {
        return clones.length ? clones[0].offsetLeft - originals[0].offsetLeft : 0;
      }

      function step(now) {
        frame = window.requestAnimationFrame(step);
        var elapsed = Math.min(now - last, 100);
        last = now;
        if (paused) return;
        var width = half();
        if (!width) return;
        position += (SPEED * elapsed) / 1000;
        if (position >= width) position -= width;
        list.scrollLeft = position;
      }

      // Boucle : quand on dépasse une série complète (défilement ou glissement), on revient d'autant
      function wrap() {
        var width = half();
        if (!width) return;
        if (list.scrollLeft >= width) {
          list.scrollLeft -= width;
        }
      }

      function hold() {
        paused = true;
        window.clearTimeout(resumeTimer);
      }

      function release() {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(function () {
          position = list.scrollLeft;
          paused = false;
        }, RESUME_DELAY);
      }

      function start() {
        if (clones.length) return;
        originals.forEach(function (item) {
          var copy = item.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-shopify-editor-block');
          list.appendChild(copy);
          clones.push(copy);
        });
        list.addEventListener('scroll', wrap, { passive: true });
        list.addEventListener('touchstart', hold, { passive: true });
        list.addEventListener('pointerdown', hold, { passive: true });
        list.addEventListener('wheel', hold, { passive: true });
        list.addEventListener('touchend', release, { passive: true });
        list.addEventListener('touchcancel', release, { passive: true });
        list.addEventListener('pointerup', release, { passive: true });
        list.addEventListener('wheel', release, { passive: true });
        position = list.scrollLeft;
        paused = false;
        last = window.performance.now();
        frame = window.requestAnimationFrame(step);
      }

      function stop() {
        window.cancelAnimationFrame(frame);
        window.clearTimeout(resumeTimer);
        list.removeEventListener('scroll', wrap);
        list.removeEventListener('touchstart', hold);
        list.removeEventListener('pointerdown', hold);
        list.removeEventListener('wheel', hold);
        list.removeEventListener('touchend', release);
        list.removeEventListener('touchcancel', release);
        list.removeEventListener('pointerup', release);
        list.removeEventListener('wheel', release);
        clones.forEach(function (copy) {
          copy.remove();
        });
        clones = [];
        list.scrollLeft = 0;
      }

      function update() {
        // Défilement automatique : mobile seulement, et jamais si le visiteur réduit les animations
        if (mobile.matches && !reduced.matches && originals.length > 1) {
          start();
        } else {
          stop();
        }
      }

      mobile.addEventListener('change', update);
      reduced.addEventListener('change', update);
      update();
    }

    function init() {
      document.querySelectorAll('[data-nh-trust]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('.nh-teaser').forEach(function (teaser) {
        if (teaser.dataset.nhReady) return;
        teaser.dataset.nhReady = 'true';

        var video = teaser.querySelector('.nh-teaser__video');
        var controls = teaser.querySelector('.nh-teaser__controls');
        if (!video || !controls) return;

        var playButton = controls.querySelector('[data-nh-teaser="play"]');
        var soundButton = controls.querySelector('[data-nh-teaser="sound"]');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Mis en pause par le visiteur : le film ne repart pas tout seul en revenant à l'écran
        var userPaused = reducedMotion;

        // Avec le script : boutons sobres à la place des commandes natives du navigateur
        video.muted = true;
        video.removeAttribute('controls');
        controls.hidden = false;

        function setState(button, on) {
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
          button.setAttribute('aria-label', on ? button.dataset.labelOn : button.dataset.labelOff);
        }

        function play() {
          var attempt = video.play();
          if (attempt && attempt.catch) {
            attempt.catch(function () {
              setState(playButton, true);
            });
          }
        }

        video.addEventListener('play', function () {
          setState(playButton, false);
        });
        video.addEventListener('pause', function () {
          setState(playButton, true);
        });

        playButton.addEventListener('click', function () {
          if (video.paused) {
            userPaused = false;
            play();
          } else {
            userPaused = true;
            video.pause();
          }
        });

        soundButton.addEventListener('click', function () {
          video.muted = !video.muted;
          setState(soundButton, !video.muted);
          if (!video.muted && video.paused) {
            userPaused = false;
            play();
          }
        });

        if (reducedMotion) {
          setState(playButton, true);
          return;
        }

        if (!('IntersectionObserver' in window)) {
          play();
          return;
        }

        new IntersectionObserver(
          function (entries) {
            var visible = entries[0].isIntersecting;
            if (visible && !userPaused && video.paused) play();
            if (!visible && !video.paused) video.pause();
          },
          { threshold: 0.35 }
        ).observe(video);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
